// Única fuente de verdad de los tipos de clase: la usan la sección de Tarifas
// (Pricing) y el selector de la sección de Reservas (Booking).
export const CLASS_PLANS = {
  es: [
    {
      id: 'prueba',
      name: 'Clase de prueba',
      duration: '30 min',
      price: 'Gratis',
      priceNum: '0€',
      description: 'Primera clase para conocernos y evaluar tu nivel.',
      features: ['Sin compromiso', 'Evaluación de nivel', 'Plan personalizado'],
      featured: false,
      free: true,
    },
    {
      id: 'individual',
      name: 'Clase individual',
      duration: '55 min',
      price: '15€',
      description: 'Clase 1-a-1 totalmente personalizada.',
      features: ['Enfoque a tus objetivos', 'Material incluido', 'Feedback personal'],
      featured: false,
    },
    {
      id: 'pack5',
      name: 'Pack 5 clases',
      duration: '5 × 55 min',
      price: '65€',
      perClassPrice: '13€',
      save: '10€',
      description: 'Ideal si quieres progresar de forma constante.',
      features: ['5 clases individuales', 'Ahorra 10€', 'Sin caducidad'],
      featured: false,
    },
    {
      id: 'pack10',
      name: 'Pack 10 clases',
      duration: '10 × 55 min',
      price: '120€',
      perClassPrice: '12€',
      save: '30€',
      description: 'La mejor relación calidad-precio.',
      features: ['10 clases individuales', 'Ahorra 30€', 'Sin caducidad'],
      featured: true,
    },
    {
      id: 'dele',
      name: 'Preparación DELE',
      duration: '60 min',
      price: '18€',
      description: 'Preparación especializada para el examen DELE.',
      features: ['Material específico', 'Simulacros de examen', 'Corrección detallada'],
      featured: false,
    },
    {
      id: 'dele_pack5',
      name: 'Bono Preparación DELE',
      duration: '5 × 60 min',
      price: '80€',
      perClassPrice: '16€',
      save: '10€',
      description: 'Prepara tu examen DELE con cinco clases individuales adaptadas a tu nivel y a las pruebas que necesitas mejorar.',
      features: ['5 clases de 60 min', 'Simulacros y estrategias', 'Ahorras 10€'],
      featured: false,
    },
  ],
  en: [
    { id: 'prueba', name: 'Trial class', duration: '30 min', price: 'Free', priceNum: '€0', description: 'First class to get to know each other and assess your level.', features: ['No commitment', 'Level assessment', 'Personalized plan'], featured: false, free: true },
    { id: 'individual', name: 'Individual class', duration: '55 min', price: '€15', description: 'Fully personalized 1-on-1 class.', features: ['Goal-focused', 'Materials included', 'Personal feedback'], featured: false },
    { id: 'pack5', name: '5-class pack', duration: '5 × 55 min', price: '€65', perClassPrice: '€13', save: '€10', description: 'Ideal to progress steadily.', features: ['5 individual classes', 'Save €10', 'No expiration'], featured: false },
    { id: 'pack10', name: '10-class pack', duration: '10 × 55 min', price: '€120', perClassPrice: '€12', save: '€30', description: 'Best value for money.', features: ['10 individual classes', 'Save €30', 'No expiration'], featured: true },
    { id: 'dele', name: 'DELE preparation', duration: '60 min', price: '€18', description: 'Specialized preparation for the DELE exam.', features: ['Specific materials', 'Mock exams', 'Detailed correction'], featured: false },
    { id: 'dele_pack5', name: 'DELE preparation pack', duration: '5 × 60 min', price: '€80', perClassPrice: '€16', save: '€10', description: 'Prepare your DELE exam with five individual classes focused on your level and the papers you need to improve.', features: ['5 classes of 60 min', 'Mock exams and strategies', 'Save €10'], featured: false },
  ],
  de: [
    { id: 'prueba', name: 'Probestunde', duration: '30 Min', price: 'Kostenlos', priceNum: '0€', description: 'Erste Stunde zum Kennenlernen und Niveau-Test.', features: ['Unverbindlich', 'Niveau-Einstufung', 'Persönlicher Plan'], featured: false, free: true },
    { id: 'individual', name: 'Einzelstunde', duration: '55 Min', price: '15€', description: 'Vollständig personalisierte 1-zu-1-Stunde.', features: ['Auf deine Ziele fokussiert', 'Material inklusive', 'Persönliches Feedback'], featured: false },
    { id: 'pack5', name: '5er-Paket', duration: '5 × 55 Min', price: '65€', perClassPrice: '13€', save: '10€', description: 'Ideal für konstanten Fortschritt.', features: ['5 Einzelstunden', 'Spare 10€', 'Kein Ablaufdatum'], featured: false },
    { id: 'pack10', name: '10er-Paket', duration: '10 × 55 Min', price: '120€', perClassPrice: '12€', save: '30€', description: 'Das beste Preis-Leistungs-Verhältnis.', features: ['10 Einzelstunden', 'Spare 30€', 'Kein Ablaufdatum'], featured: true },
    { id: 'dele', name: 'DELE-Vorbereitung', duration: '60 Min', price: '18€', description: 'Spezialisierte Vorbereitung auf die DELE-Prüfung.', features: ['Spezifisches Material', 'Musterprüfungen', 'Detaillierte Korrektur'], featured: false },
    { id: 'dele_pack5', name: 'DELE-Vorbereitungspaket', duration: '5 × 60 Min', price: '80€', perClassPrice: '16€', save: '10€', description: 'Bereite deine DELE-Prüfung mit fünf Einzelstunden vor, abgestimmt auf dein Niveau und die Prüfungsteile, die du verbessern willst.', features: ['5 Stunden à 60 Min', 'Musterprüfungen und Strategien', 'Spare 10€'], featured: false },
  ],
};

export const getPlans = (language) => CLASS_PLANS[language] || CLASS_PLANS.es;
